import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { Traitement } from '@app/models/carnet-liaison';
import { CarnetHeureFormatPipe } from '../../carnet-liaison.pipe';
import { getSurveillanceSymptomes } from '../../carnet-liaison.utils';
import {
  MEDICAMENT_ADMINISTRE_LABELS,
  POSOLOGIE_LABELS,
  COMMENT_PARENT_AVERTI_LABELS,
} from '../../carnet-liaison.constants';

@Component({
  selector: 'app-carnet-traitement',
  templateUrl: './carnet-traitement.component.html',
  styleUrl: './carnet-traitement.component.scss',
  standalone: true,
  imports: [SharedModule, CarnetHeureFormatPipe],
})
export class CarnetTraitementComponent {
  data = input.required<Traitement>();

  readonly medicamentAdministreLabels = MEDICAMENT_ADMINISTRE_LABELS;
  readonly posologieLabels = POSOLOGIE_LABELS;
  readonly commentParentAvertiLabels = COMMENT_PARENT_AVERTI_LABELS;

  getSurveillanceSymptomes = getSurveillanceSymptomes;
}
